"use client";

import React from "react";
import Link from "next/link";

const AgeGateTermsAndPrivacy: React.FC = () => {
  return (
    <div className="text-sm mt-auto">
      By accessing this site, you accept the{" "}
      <Link className="underline" href="/info/terms-of-use">
        Terms of Use
      </Link>{" "}
      and{" "}
      <Link className="underline" href="/info/privacy-policy">
        Privacy Policy
      </Link>
      .
    </div>
  );
};

export default AgeGateTermsAndPrivacy;
